import OvertimeEvent from '@/components/requests/overtime/events/OvertimeEvent'

export default class OvertimeDeclinedEvent extends OvertimeEvent {
  constructor(event) {
    super(event)
  }

  asNotice(viewer) {
    return `
        Overtime request was declined by
        ${this.getActorName(viewer)}
        on
        ${this._createdAtText(viewer)}.
      `
  }

  asText(viewer) {
    return `
      **${this.getActorName(viewer)}**
      declined the request
    `
  }
}
